module.exports = __webpack_public_path__ + "img/icon_wy04.1c8861a8.png";